/**
 * @generated SignedSource<<a19f378165c86254d6e8534265e8d489>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useJobApplication_Job$data = {
  readonly firm: {
    readonly slug: string | null | undefined;
  } | null | undefined;
  readonly jobApplication: {
    readonly " $fragmentSpreads": FragmentRefs<"useJobApplication_JobApplication">;
  } | null | undefined;
  readonly slug: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"job_useApplyToJob">;
  readonly " $fragmentType": "useJobApplication_Job";
};
export type useJobApplication_Job$key = {
  readonly " $data"?: useJobApplication_Job$data;
  readonly " $fragmentSpreads": FragmentRefs<"useJobApplication_Job">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useJobApplication_Job",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Firm",
      "kind": "LinkedField",
      "name": "firm",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "JobApplication",
      "kind": "LinkedField",
      "name": "jobApplication",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useJobApplication_JobApplication"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "job_useApplyToJob"
    }
  ],
  "type": "Job",
  "abstractKey": null
};
})();

(node as any).hash = "7085a3ab54735e82863441ce5e7772e8";

export default node;
